import { View, ViewModel } from "binder";
import { SelectorBaseViewModel } from "src/common/reusableComponents/selectorBase/selectorBase-viewModel";
import { ServerConnection } from "src/server/serverConnection";


export class IbanSelectorSelectorViewModel extends SelectorBaseViewModel<iban>{
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);
    }

    public getTypeId(): string {
        return "VM-88942B5E-C379-4C92-8F53-B0654A1CA75C"
    }

    protected async loadData(): Promise<iban[]> {
        let result =await ServerConnection.callServer('/Complex/ArapRawDataServices/GetAccessibleIbanGateways',{})
        return result.Gateways.map(x=>{
            let r = new iban(this);
            r.id = x.Id;
            r.title = `${x.AccountName} - ${x.SerialNumber}`;
            return r;
        });
    }

}

export class iban extends ViewModel{
    public getTypeId(): string {return '';}
    public GetDefaultView(): View<ViewModel> {return null;}
    constructor(parent:ViewModel) {
        super(parent);
        
    }
    
    public set id(v: string) { this._id = v; } public get id(): string { return this._id;} private _id: string;
    public set title(v: string) { this._title = v; } public get title(): string { return this._title;} private _title: string;
    
}